export default __webpack_public_path__ + "static/media/slide13.ea3ab16f.webp";